import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Avatar from 'components/common/Avatar';
import ErrorBoundary from 'components/common/ErrorBoundary';
import useToken from 'hooks/useToken';
import { useToast } from 'context/providers/ToastProvider';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap';
import ComentariosSoporte from './ComentariosSoporte';

const SoporteTecnico = ({
    agrupacionLicencias = [],
    setHabilitarBtnCombinar,
    setShowModalCombinarClientes,
    idClienteAkasia,
    emailCliente
}) => {
    const [problemaSoporte, setProblemaSoporte] = useState('');
    const { token, setToken, profileImage } = useToken();
    const { showErrorToast } = useToast();
    const [comentarios, setComentarios] = useState([]);

    const HORAS_ESPERA = 3;

    const crearComentarioSoporte = async () => {
        // Validar longitud mínima
        if (problemaSoporte.trim().length < 15) {
            showErrorToast('El problema debe tener al menos 15 caracteres.');
            return;
        }

        var jDataSend = {};
        jDataSend.vProblema = problemaSoporte;
        jDataSend.idClienteAkasia = idClienteAkasia;

        const response = await fetch("/api/cliente/RegistrarProblemaSoporte/",
            {
                method: 'POST',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(jDataSend)
            }).catch((error) => {

                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {
            console.log("==== REGISTRO DE COMENTARIO DE SOPORTE ====");

            const data = await response.json();

            if (data.iResponseType == 1) {

                var detalles = JSON.parse(data.detalles);
                const comentario = detalles.table2[0];
                setComentarios([comentario, ...comentarios]);
                setProblemaSoporte('');

            } else if (data.iResponseType == 3) {
                // El backend retorna iResponseType = 3 cuando debe esperar
                showErrorToast(data.vMessage);

            } else {

                showErrorToast(data.vMessage);
                setHabilitarBtnCombinar(false);
                setShowModalCombinarClientes(false);

            }

        }
        else {

            showErrorToast(response.status + ' ' + response.statusText);
            setHabilitarBtnCombinar(false);
            setShowModalCombinarClientes(false);

            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            console.log(response);
        }
    };

    if (agrupacionLicencias.length === 0) return null;

    return (
        <Row className="g-3 mb-3">
            <Col className="col-12">
                <Card className="mb-1">
                    <Card.Header className="border-bottom border-200">
                        <h5 className="mb-0">Soporte T&eacute;cnico</h5>
                    </Card.Header>
                    <Card.Body className="bg-light ">
                        <Form id="comment" onSubmit={(e) => {
                            e.preventDefault();
                            crearComentarioSoporte();
                        }}>
                            <div className="d-flex align-items-start mb-2">
                                <Avatar src={profileImage} size="xl" />
                                <Form.Control
                                    type="text"
                                    className="ms-2"
                                    placeholder="Describe un nuevo problema..."
                                    rows={3}
                                    value={problemaSoporte}
                                    style={{ resize: "none" }}
                                    maxLength={999}
                                    minLength={15}
                                    onChange={e => setProblemaSoporte(e.target.value)}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault();
                                            if (e.target.value.length >= 15) {
                                                crearComentarioSoporte();
                                            }
                                        }
                                    }}
                                />
                            </div>
                            {problemaSoporte.length > 0 && problemaSoporte.length < 15 && (
                                <small className="text-muted ms-5 ps-2">
                                    M&iacute;nimo 15 caracteres ({problemaSoporte.length}/15)
                                </small>
                            )}
                        </Form>
                        <ErrorBoundary>
                            <ComentariosSoporte
                                idClienteAkasia={idClienteAkasia}
                                comentarios={comentarios}
                                setComentarios={setComentarios}
                                emailCliente={emailCliente}
                            />
                        </ErrorBoundary>
                    </Card.Body>
                    <Card.Footer className="border-top text-end">
                        <small className="text-muted">
                            <FontAwesomeIcon icon="info-circle" className="me-1" />
                            Puedes crear un ticket de soporte cada {HORAS_ESPERA} horas
                        </small>
                    </Card.Footer>
                </Card>
            </Col>
        </Row>
    );
};

SoporteTecnico.propTypes = {
    agrupacionLicencias: PropTypes.array,
    setHabilitarBtnCombinar: PropTypes.func,
    setShowModalCombinarClientes: PropTypes.func,
    idClienteAkasia: PropTypes.string,
    emailCliente: PropTypes.string
};

export default SoporteTecnico;
